<template>
<div class="ActivityTempEdit">
    <activityEdit></activityEdit>
</div>
</template>

<script>
import ActivityEdit from 'views/brandBusiness/activityMgt/activity/ActivityEdit.vue'
export default {
    name: 'ActivityTempEdit',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {
        status: function (value) {
            return value
        }
    },
    watch: {},
    computed: {

    },
    components: {
        ActivityEdit
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.ActivityTempEdit {
}
</style>
